import axios from "../axios";
import * as fetchResponseHandling from "./../responseHandling/fetch";
import * as createResponseHandling from "./../responseHandling/create";

async function fetchLessons(courseId) {
  const res = await axios.get(`/students/lessons?course_id=${courseId}`);
  return fetchResponseHandling.parseResponse(res);
}

async function updateLessonProgress(lessonId) {
  const body = {
    lesson_id: lessonId
  }

  const res = await axios.post(`/students/lesson_completes`, body);
  return createResponseHandling.parseResponse(res);
}

export {
  fetchLessons,
  updateLessonProgress,
};
